// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPaymentProcessor } from './GetPaymentProcessor';
import {
  GetPaymentProcessorFromJSON,
  GetPaymentProcessorFromJSONTyped,
  GetPaymentProcessorToJSON,
  GetPaymentProcessorToJSONTyped,
} from './GetPaymentProcessor';

/**
 *
 * @export
 * @interface GetResponse
 */
export interface GetResponse {
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  billingID: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  organizationID: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  organizationProfile?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof GetResponse
   */
  projectIDs: Array<string>;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  billingModel: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  billingProcessor: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  paymentMethod: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  pricingPlan: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  reason: string;
  /**
   *
   * @type {boolean}
   * @memberof GetResponse
   */
  isFunded: boolean;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  unfundedReason: string;
  /**
   *
   * @type {string}
   * @memberof GetResponse
   */
  productCatalogueVersion?: string;
  /**
   *
   * @type {GetPaymentProcessor}
   * @memberof GetResponse
   */
  paymentProcessor?: GetPaymentProcessor;
}

/**
 * Check if a given object implements the GetResponse interface.
 */
export function instanceOfGetResponse(value: object): value is GetResponse {
  if (!('billingID' in value) || value['billingID'] === undefined) return false;
  if (!('organizationID' in value) || value['organizationID'] === undefined)
    return false;
  if (!('projectIDs' in value) || value['projectIDs'] === undefined)
    return false;
  if (!('billingModel' in value) || value['billingModel'] === undefined)
    return false;
  if (!('billingProcessor' in value) || value['billingProcessor'] === undefined)
    return false;
  if (!('paymentMethod' in value) || value['paymentMethod'] === undefined)
    return false;
  if (!('pricingPlan' in value) || value['pricingPlan'] === undefined)
    return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('email' in value) || value['email'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('reason' in value) || value['reason'] === undefined) return false;
  if (!('isFunded' in value) || value['isFunded'] === undefined) return false;
  if (!('unfundedReason' in value) || value['unfundedReason'] === undefined)
    return false;
  return true;
}

export function GetResponseFromJSON(json: any): GetResponse {
  return GetResponseFromJSONTyped(json, false);
}

export function GetResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetResponse {
  if (json == null) {
    return json;
  }
  return {
    billingID: json['billingID'],
    organizationID: json['organizationID'],
    organizationProfile:
      json['organizationProfile'] == null
        ? undefined
        : json['organizationProfile'],
    projectIDs: json['projectIDs'],
    billingModel: json['billingModel'],
    billingProcessor: json['billingProcessor'],
    paymentMethod: json['paymentMethod'],
    pricingPlan: json['pricingPlan'],
    status: json['status'],
    email: json['email'],
    name: json['name'],
    reason: json['reason'],
    isFunded: json['isFunded'],
    unfundedReason: json['unfundedReason'],
    productCatalogueVersion:
      json['productCatalogueVersion'] == null
        ? undefined
        : json['productCatalogueVersion'],
    paymentProcessor:
      json['paymentProcessor'] == null
        ? undefined
        : GetPaymentProcessorFromJSON(json['paymentProcessor']),
  };
}

export function GetResponseToJSON(json: any): GetResponse {
  return GetResponseToJSONTyped(json, false);
}

export function GetResponseToJSONTyped(
  value?: GetResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    billingID: value['billingID'],
    organizationID: value['organizationID'],
    organizationProfile: value['organizationProfile'],
    projectIDs: value['projectIDs'],
    billingModel: value['billingModel'],
    billingProcessor: value['billingProcessor'],
    paymentMethod: value['paymentMethod'],
    pricingPlan: value['pricingPlan'],
    status: value['status'],
    email: value['email'],
    name: value['name'],
    reason: value['reason'],
    isFunded: value['isFunded'],
    unfundedReason: value['unfundedReason'],
    productCatalogueVersion: value['productCatalogueVersion'],
    paymentProcessor: GetPaymentProcessorToJSON(value['paymentProcessor']),
  };
}
